/**
 * 머큐리 회원가입 인증코드 (/m/signup/sosok — 머큐리 앱) — 코드 칸 자동 이동·확인
 * ($j.Pages.Mobile.SignupSosokMercury / body data-page-name="SignupSosokMercury")
 */
export default class SignupSosokMercury {
    initialize() {
        $(function(){
            initHandler();
            $('#mcSubmit').on('click', onSubmit);
        });

        function initHandler(){
            /**
             * join blade에서 준 오류메세지 띄워주기.
             * 확인을 누르면 로그인으로 보낸다 — ✕ 로 닫으면 이 화면에 남는다(구 모달과 같은 동작).
             */
            window.addEventListener('message', async function(event) {
                const ok = await $j.Ui.Dialog.alert(event.data.message);
                if (ok) location.replace('/m/login');
            });

            /** 인증코드 키다운 */
            const inputElements = [...document.querySelectorAll('input.form-control')]
            inputElements.forEach((ele,index)=>{
                ele.addEventListener('keydown',(e)=>{
                    if(e.keyCode === 8 && e.target.value==='') inputElements[Math.max(0,index-1)].focus()
                })
                ele.addEventListener('input',(e)=>{
                    const [first,...rest] = e.target.value
                    e.target.value = first ?? ''
                    const lastInputBox = index===inputElements.length-1
                    const didInsertContent = first!==undefined
                    if(didInsertContent && !lastInputBox) {
                        inputElements[index+1].focus()
                        inputElements[index+1].value = rest.join('')
                        inputElements[index+1].dispatchEvent(new Event('input'))
                    }
                })
            })
        }

        function onSubmit(){
            const inputElements = [...document.querySelectorAll('input.form-control')];
            const code = inputElements.map(({value})=>value).join('')
            $.ajax({
                url: '/mc/verifycode',
                method: 'POST',
                data: {
                    code: code,

                },
                success: function (response) {
                    if (response.success) {
                        location.href='/m/signup/form';
                    } else {
                        $j.Common.Util.swalert('유효하지 않은 코드입니다.');
                    }
                },
                error: function (xhr, status, error) {
                    alert('오류가 발생했습니다. 다시 시도해 주세요.');
                }
            });
        }

    }
}
